const redirect = {
  namespaced: true,
  state: {
    multiLoginDraft: false,
    customerFromDraft: {},
    finishDraftRedirect: [false, false], 
    // [0] indicate finish loading patient 
    // [1] indicate finish loading draftItem
  },
  getters: {
    finishedRedirect(state) {
      return state.finishDraftRedirect[0] && state.finishDraftRedirect[1];
    }
  },
  mutations: {
    SET_MULTI_LOGIN_DRAFT(state, multiLoginDraft) {
      state.multiLoginDraft = multiLoginDraft;
    },
    SET_CUSTOMER_FROM_DRAFT(state, customer) {
      state.customerFromDraft = customer;
    },
    SET_FINISH_LOAD_ORDER_TEST(state) {
      state.finishDraftRedirect[0] = true;
    },
    SET_FINISH_LOAD_ORDER_PAGE(state) {
      state.finishDraftRedirect[1] = true;
    }
  },
  actions: {
    setMultiLoginDraft({ commit }, multiLoginDraft) {
      commit('SET_MULTI_LOGIN_DRAFT', multiLoginDraft);
    },
    setCustomerFromDraft({ commit }, customer) {
      commit('SET_CUSTOMER_FROM_DRAFT', customer);
    },
  }
};

export default redirect;
